import { JSX } from 'react';

import ErrorBox from './ErrorBox';
import SuccessBox from './SuccessBox';

export interface StatusMessageProps {
    message?: string;
    success?: boolean;
    onDismiss?: () => void;
    className?: string;
}

export default function StatusMessage({
    message,
    success = false,
    onDismiss,
    className = '',
}: StatusMessageProps): JSX.Element | null {
    if (!message) {
        return null;
    }

    if (success) {
        return <SuccessBox message={message} onDismiss={onDismiss} className={className} />;
    }

    return <ErrorBox message={message} onDismiss={onDismiss} className={className} />;
}
